__turbopack_context__.v({
  "bandCaption": "HeroStatsBand-module-scss-module__vahfiW__bandCaption",
  "bandCaptionLine": "HeroStatsBand-module-scss-module__vahfiW__bandCaptionLine",
  "bandItem": "HeroStatsBand-module-scss-module__vahfiW__bandItem",
  "bandStat": "HeroStatsBand-module-scss-module__vahfiW__bandStat",
  "belowCtasBand": "HeroStatsBand-module-scss-module__vahfiW__belowCtasBand",
  "belowCtasBandFans": "HeroStatsBand-module-scss-module__vahfiW__belowCtasBandFans",
  "belowCtasBandForClubs": "HeroStatsBand-module-scss-module__vahfiW__belowCtasBandForClubs",
  "belowCtasBandHome": "HeroStatsBand-module-scss-module__vahfiW__belowCtasBandHome",
  "fansStatsMarquee": "HeroStatsBand-module-scss-module__vahfiW__fansStatsMarquee",
  "marqueeGroup": "HeroStatsBand-module-scss-module__vahfiW__marqueeGroup",
  "marqueeTrack": "HeroStatsBand-module-scss-module__vahfiW__marqueeTrack",
  "marqueeViewport": "HeroStatsBand-module-scss-module__vahfiW__marqueeViewport",
});
